export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* 背景 */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/74e9d32df0411ab24c69a2c79c0f3a38.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>
      </div>

      {/* コンテンツ */}
      <div className="relative z-10 text-center px-6 w-full select-none" onCopy={(e) => e.preventDefault()} onContextMenu={(e) => e.preventDefault()}>
        <div className="flex justify-center mb-8">
          <img
            src="https://static.readdy.ai/image/6902dd986b6e328bf9bb68047035d84f/5fb36d5e9028b47c0fac686a51ca35fe.png"
            alt="NACHTEULE CREATION Logo"
            className="h-32 w-32 object-contain animate-pulse"
          />
        </div>

        <h1 className="text-5xl md:text-7xl font-bold mb-6 tracking-wider">
          NACHTEULE CREATION
        </h1>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="#business"
            className="px-8 py-4 bg-purple-600 hover:bg-purple-700 text-white font-medium rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            VIEW BUSINESS
          </a>
          <a
            href="#contact"
            className="px-8 py-4 bg-transparent border-2 border-white hover:bg-white hover:text-black text-white font-medium rounded-lg transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            CONTACT US
          </a>
        </div>

        <div className="mt-16 animate-bounce">
          <i className="ri-arrow-down-line text-4xl text-purple-400"></i>
        </div>
      </div>
    </section>
  );
}
